import React, {Component} from 'react';
import Camera from 'react-html5-camera-photo';
import PropTypes from 'prop-types';
import Alert from '../../../Helper/SimpleAlert/alert';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {Grid,Avatar,Button,Modal,MenuItem,Menu} from '@material-ui/core';
import {GetPotential} from '../../../Actions/dealActions';
import converter from '../../../Helper/convertFile';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles =theme=>({
	root: {
		flexGrow: 1,
	},
	button: {
		float: 'right',
		fontSize: '20px',
		marginTop: '20px',
		border: '3px solid #ddd',
		borderRadius: '10px',
		padding: '0',
	},
    progress: {
        margin: 0,
        color:'#fff',
        fontWeight:500
    },
	buttonColor:{
		backgroundColor:'#851679',
    float: 'right',
    fontSize: '20px',
    marginTop: '20px',
    border: '3px solid #ddd',
    borderRadius: '10px',
    padding: '0',
		color:'white'
	},
  pickerFont:{
    fontSize:'2.6rem'
  },
  typography: {
    padding: theme.spacing.unit * 2,
		fontSize:'15px'
  }
  ,menuItem:{
	  width:'400px',
  }
});

class PostWebView extends Component {
  constructor () {
    super();
    this.state = {
      postComment: '',
      picture: '',
      length: 0,
      hash: false,
      openPopper: false,
      anchorEl: null,
      enablePost: false,
      edit: false,
			openCamera:false,
      previewImage:'',
      showAlert:false,
      msg:""
    }
  }

  checkProfileImg = (url) => {
    const {user} = this.props;
    if (url === null || url === "") {
      return <img
				src={require(`../../../images/Alphabets/${user.results.AppUser.FirstName.substring(0, 1).toUpperCase()}.png`)}
				height={50} width={50}/>
    } else {
      return <img
				src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${url}`}
				height={50} width={50}/>
    }
  };
  changeHandler = (e) => {
    let urls="";
     let exp=/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm
    if(e.target.value[e.target.value.length-1] === " "){
      let previewImage="";
      urls = e.target.value.match(exp);
      if(urls) {
        previewImage = `https://${urls}/favicon.ico`
        this.setState({previewImage});
      }
      else{
        this.setState({previewImage:""});
      }

    }
    if (e.target.value.length <= 200) {
      this.setState({
        postComment: e.target.value,
        length: e.target.value.length,
      });
      if ((e.target.value).trim().length === 0)
        this.setState({enablePost: false,previewImage:""})
      else
        this.setState({enablePost: true})
    }
  };

  componentWillReceiveProps (nextProps) {

  	this.setState({postComment:'',length: 0})
    if(nextProps.editData !== null && nextProps.editData!== '') {
      if (nextProps.editData === 'image post') {
        this.setState({postComment: "", length: 0, enablePost: true})
        this.setState({edit: true})
      }
      else {  this.setState({postComment: nextProps.editData, length: nextProps.editData.length,enablePost:true})
      this.setState({edit: true})}
    }
    else {
        this.setState({postComment: "", length: 0, enablePost: false})
        // this.setState({edit: true})
    }
  }

  pictureHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({picture:""})
    if(e.target.files[0].type==='image/png' ||e.target.files[0].type==='image/jpg' ||e.target.files[0].type==='image/jpeg')
    {
      converter.toBase64(e.target.files[0]).then((dt) => {
        this.setState({
          picture: dt
        });
      });
    }
    else{
        this.props.showAlert(true,"Invalid File type , Please select file of .png .jpg or .jpeg type only.");
    }
    e.target.value = '';

  }

  componentDidMount () {
    let {user} = this.props;
    this.props.GetPotential(user.results.AppUser.UserId,
      user.results.BusinessUser.Address_Lat,
      user.results.BusinessUser.Address_Long, 'post');

      this.setState({postComment: "", length: 0, enablePost: false})
      this.setState({edit: false})
  }

  postHandler = (e) => {
    let {postComment, picture, cameraPhoto} = this.state;
    if (e.target.innerText === 'POST') {
      this.props.onUpload({PostComment: postComment, Picture: picture, CameraPhoto: cameraPhoto}, 'Add');
    }
    else {
      this.setState({enablePost:true})
      this.props.onUpdate(postComment);
    }
    this.setState({
      postComment: '',
      picture: '',
      length: 0,
      edit: false,
        enablePost:false
    })
  };

  addHash = () => {
    let data = document.getElementById('message').value;
    if (data.length <= 200) {
      this.setState({
        postComment: data + "#",
        length: data.length + 1
      }, () => {
        if (this.state.postComment.trim().length === 0)
          this.setState({enablePost: false})
        else
          this.setState({enablePost: true})
      });
    }
  }

	showCamera = () => {

  	this.setState({openCamera:true});
		// let modal = document.getElementById('cameraModal');
		// modal.style.display = "block";
	};

  convertUnicode = (input) => {
    return input.replace(/\\u(\w\w\w\w)/g,(a,b) => {
      let charcode = parseInt(b,16);
      return String.fromCharCode(charcode);
    });
  };

  toggleCamera=()=>this.setState({openCamera:false})

  handleImage=(event)=>{
    const { currentTarget } = event;
  	this.setState({anchorEl:currentTarget});



	}

  onCameraClick=(image)=>{
  	this.setState({picture:image,openCamera:false});
	}

  onCameraError=(e)=>{
    if(e.toString() === "NotFoundError: Requested device not found") {
      this.toggleCamera();
      this.props.showAlert(true,"Please connect camera to use this functionality.");
    }
    else if (e.toString().includes("Only secure origins are allowed")) {
      this.props.showAlert(true,`${window.location.origin} is not secured.`);
      this.props.toggleCamera();
    }
    else if (e.toString().includes("Permission denied")) {
      this.props.toggleCamera();
      this.props.toggleAlert(`Permission Denied. Please allow the camera to use this functionality.`);
    }
    else if(e.toString().includes('no stream to stop!')) {

    }
    else {
      this.props.toggleCamera();
      this.props.toggleAlert(`Something went wrong while accessing camera.`);
      console.log(e);
    }
    this.setState({openCamera:false})
  }

  cancelImage=()=>{this.setState({picture:'',openPopper:false,previewImage:""})}

  handleClose=()=>{
   this.setState({anchorEl:null})
  }

  removeImage=()=>{
    this.setState({picture:"",anchorEl:null})
  }

	render() {
		const { classes,user,potentialCount } = this.props;
		const {postComment,picture,previewImage} = this.state;
		return (
			<div>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.openCamera}
					onClose={this.state.toggleCamera}
				>
					<div className="display-camera">
						<Camera
							onTakePhoto={this.onCameraClick}
							onCameraError={this.onCameraError}

						/>
					</div>
				</Modal>
        <Alert onClose={this.alertCallback} showSuccess={false} showError={this.state.showAlert} Msg={this.state.msg}/>
				<div className={classes.root}>
					<Grid container spacing={12}>
						<Avatar className="avatar-img">
              {this.checkProfileImg(user.results.AppUser.ProfileImage)}
						</Avatar>
						<Grid item sm={6} xs={6} className='avatar-title'>
							<span className="user-name-post">{user.results.AppUser.FirstName}</span><br />
							<span class="user-name-post-email">{`@ ${user.results.AppUser.UserName}`}</span>
						</Grid>
                        <div className='potential-button'>
                                <span className="potential-button-inner-text">
                                    Your Post Has<br/>Potential Reach <br/>
                                    of {(!potentialCount.results.countReceived)?
                                    <CircularProgress size={15} className={classes.progress}/>
                                    :
                                    potentialCount.results.Count && potentialCount.results.Count
                                } People
                                </span>
                        </div>
						{/*<Grid item sm={4} xs={4} className="gridFont">*/}

						{/*</Grid>*/}
					</Grid>
					<div className="mt-1">
						<div style={{width:'90%',marginTop:"30px"}}>
						<textarea id="message" name="postMessage" value={postComment} draggable={false} placeholder="What's on your mind?" onChange={this.changeHandler} ondragstart="return false;" ondrop="return false;"/>
						</div>
						<div className="post-creat-img">
							{picture || previewImage ?
                picture ? <img src={picture} width="80px" height="80px" onClick={this.handleImage}/>
							:
                <img src={previewImage} width={30} height={30} onClick={this.handleImage}/>
                :
                ""
							}
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleClose}
                classes={classes.menuItem}
                PopoverClasses={{
                  className:classes.menuItem
                }}
              >
                <MenuItem onClick={this.removeImage}>Remove Image</MenuItem>
              </Menu>
						</div>
					</div>
					<div className="bottom-border">
						<span className="mt-2">{200 - (this.state.length)}</span>
					</div>
					<div className="icons">
						<input type="file" ref="img" onChange={this.pictureHandler}
						       style={{display: 'none'}}/>
						<Button variant="outlined" className={this.state.enablePost?classes.buttonColor:classes.button} onClick={this.postHandler} disabled={this.state.enablePost?false:true}>{this.state.edit?'Update':'Post'}</Button>
						<i className="fa fa-camera" aria-hidden="true" style={{marginLeft: '3%'}} onClick={this.showCamera}/>
						<i className="fa fa-picture-o" aria-hidden="true" style={{marginLeft: '3%'}} onClick={() => this.refs.img.click()}/>
						<i className="fa fa-hashtag" aria-hidden="true" style={{marginLeft: '3%'}} onClick={this.addHash}/>
					</div>
				</div>
        {/*{previewImage!=="" &&<div id="image">*/}
          {/*<img src={`${previewImage}`} width={60} heigh={60}/>*/}
        {/*</div>}*/}
			</div>
		)
	}
}
PostWebView.propTypes = {
	classes: PropTypes.object.isRequired,
};
const mapStateToProps=(state)=> {
  return {
    potentialCount:state.potentialCount
  }
};
const matchDispatchToProps=(dispatch)=> {
  return bindActionCreators({
    GetPotential
  },dispatch)
};
export default withStyles(styles)(connect(mapStateToProps,matchDispatchToProps)(PostWebView));